import { HomeFeaturedArticleType } from '@nextTypes/guides';
import { RecipesAndGuidesContainer } from '@components/RecipesAndGuides/RecipesAndGuidesContainer';
import { createImageCards } from './RecipesAndGuidesUtils';

type Props = {
  articles: HomeFeaturedArticleType[];
};

export const LifestyleSection = ({ articles }: Props): JSX.Element => {
  const cards = createImageCards(articles, 4, true);
  return (
    <RecipesAndGuidesContainer
      backgroundColour="bg-purple"
      buttonColour="NavyBlue"
      categoryTitle="Lifestyle"
      categoryTitleColour="text-mono-white"
      cta="More Lifestyle"
      ctaColour="text-mono-white"
      href="/guides/category/lifestyle"
      description="Choosing a weight loss programme? Looking for ways to stay healthy on holidays? Find helpful tips and advice to navigate your lifestyle changes here."
      descriptionColour="text-blue"
    >
      <div className="flex flex-col items-center">
        <div className="m-auto mb-8 grid grid-cols-1 justify-items-center gap-6 text-blue lg:mb-12 lg:grid-cols-2">
          {cards}
        </div>
      </div>
    </RecipesAndGuidesContainer>
  );
};
